import * as React from "react";

import { cn } from "@/lib/utils";
import { Label } from "../label";

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  isError?: boolean;
  label?: string;
  labelClassName?: string;
  containerClassName?: string;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  (
    {
      className,
      type,
      isError = false,
      label,
      labelClassName,
      containerClassName,
      id,
      ...props
    },
    ref
  ) => {
    const generatedId = React.useId();
    const inputId = id ?? (label ? generatedId : undefined);

    const borderColor = isError ? "border-destructive" : "border-input";

    const inputElement = (
      <input
        type={type}
        id={inputId}
        className={cn(
          `flex h-12 w-full rounded-lg border bg-muted px-3 py-2 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 ${borderColor} text-foreground placeholder:font-normal placeholder:tracking-normal placeholder:text-muted-foreground`,
          className
        )}
        ref={ref}
        {...props}
      />
    );

    if (label) {
      return (
        <div className={cn("flex flex-col gap-3", containerClassName)}>
          <Label
            htmlFor={inputId}
            className={cn("justify-center self-stretch", labelClassName)}
          >
            {label}
          </Label>
          {inputElement}
        </div>
      );
    }

    return inputElement;
  }
);

Input.displayName = "Input";

export default Input;
